export default __webpack_public_path__ + "static/sam-with-rocket-and-gus-da231c67edc73b4efc626f3e8e184715.webp";